import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Drawer, Button } from '@material-ui/core';
import { FilterList, Check, Close } from '@material-ui/icons';
import { Form } from '@unform/web';
import { find, isEmpty, isFunction, isNull, forEach } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import { Input, Select, DateTime, Autocomplete } from '~/components/Form';
import { convertType, t } from '~/helpers';

import { Container, GroupButton } from './styles';

export default function Filtro({
  filter,
  reset,
  params,
  data,
  initials,
  unique,
}) {
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const [opened, setOpened] = useState(false);
  const [forms, setForms] = useState({});

  function serializeDateTime(ob, value) {
    const { type, serialize } = ob;

    switch (type) {
      case 'initialdate':
      case 'finaldate':
        return moment(value).format('DD/MM/YYYY');
      case 'initialdatetime':
        return moment(value).set({ second: 0 }).format('DD/MM/YYYY HH:mm:ss');
      case 'finaldatetime':
        return moment(value).set({ second: 59 }).format('DD/MM/YYYY HH:mm:ss');
      default:
        return isFunction(serialize) ? serialize(value) : value;
    }
  }

  async function handleSubmit(param) {
    const wherefield = [];
    const valuewherefield = [];
    const typewherefield = [];

    if (!isEmpty(unique)) {
      forEach(unique.wherefield, (where) => wherefield.push(where));
      forEach(unique.valuewherefield, (value) => valuewherefield.push(value));
      forEach(unique.typewherefield, (type) => typewherefield.push(type));
    }

    Object.keys(JSON.parse(JSON.stringify(param))).map((form) => {
      const defObj = find(data, (d) => d.name === form);
      const defValue = serializeDateTime(defObj, param[form]);

      if (!isNull(defValue)) {
        wherefield.push(form);
        valuewherefield.push(defValue);
        typewherefield.push(
          isFunction(defObj.ruleType)
            ? defObj.ruleType(defValue)
            : convertType(defObj.type)
        );
      }

      return true;
    });

    setForms(param);

    await dispatch(
      filter({
        ...params,
        page: 1,
        wherefield,
        valuewherefield,
        typewherefield,
      })
    );
  }

  async function handleResetForm() {
    await dispatch(reset({ page: 1 }));
    await setOpened(false);
    await formRef.current.reset();
    setForms({});
  }

  function renderInput(input) {
    const { type, name, label, options, param, ...rest } = input;
    switch (type) {
      case 'text':
      case 'number':
      default:
        return <Input type={type} name={name} label={label} {...rest} />;
      case 'select':
        return <Select name={name} label={label} options={options} {...rest} />;
      case 'initialdate':
      case 'initialdatetime':
      case 'finaldatetime':
      case 'finaldate':
        return <DateTime name={name} label={label} {...rest} />;
      case 'autocomplete':
        return (
          <Autocomplete
            name={name}
            label={param.label}
            url={param.url}
            unique={param.unique}
            title={label}
          />
        );
    }
  }

  useEffect(() => {
    if (!isEmpty(initials) && !isEmpty(formRef.current)) {
      formRef.current.setData(initials);
    }
  }, [initials]);

  return (
    <>
      <Button onClick={() => setOpened(true)} color="primary">
        <FilterList />
      </Button>

      <Drawer anchor="right" open={opened} onClose={() => setOpened(false)}>
        <Container>
          <Form
            onSubmit={handleSubmit}
            ref={formRef}
            initialData={{ ...initials, ...forms }}
          >
            {data.map((d) => renderInput(d))}
          </Form>

          <GroupButton>
            <Button
              startIcon={<Check />}
              color="primary"
              variant="outlined"
              onClick={() => formRef.current.submitForm()}
            >
              {t('s.geral.botaoconfirmar')}
            </Button>

            <Button
              startIcon={<Close />}
              color="secondary"
              variant="outlined"
              onClick={() => handleResetForm()}
            >
              {t('s.geral.botaoresetar')}
            </Button>
          </GroupButton>
        </Container>
      </Drawer>
    </>
  );
}

Filtro.propTypes = {
  filter: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  params: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  initials: PropTypes.objectOf(PropTypes.any),
  unique: PropTypes.objectOf(PropTypes.any),
};

Filtro.defaultProps = {
  initials: {},
  unique: {},
};
